export default {
  CONTACT_POINT_SOWOS_MODERATE_REPOSITORY: Symbol.for('CONTACT_POINT_SOWOS_MODERATE_REPOSITORY'),
  GET_MODERATE_INFORMATION_BY_EMAIL_QUERY: Symbol.for('GET_MODERATE_INFORMATION_BY_EMAIL_QUERY'),
  SEARCH_ANSWERS_INITIAL_POLL_QUERY: Symbol.for('SEARCH_ANSWERS_INITIAL_POLL_QUERY'),
  CREATE_RESPONSE_NOT_READY_TO_CONTRACT_MODERATE_COMMAND: Symbol.for('CREATE_RESPONSE_NOT_READY_TO_CONTRACT_MODERATE_COMMAND'),
  SEARCH_ANSWERS_EXIT_POLL_QUERY: Symbol.for('SEARCH_ANSWERS_EXIT_POLL_QUERY'),
  CREATE_RESPONSE_UNLINK_GOAL_FROM_MODERATE_COMMAND: Symbol.for('CREATE_RESPONSE_UNLINK_GOAL_FROM_MODERATE_COMMAND'),
};
